export default "__VITE_ASSET__55e741f5__"